import {cn} from './lib/utils';

export interface NavLinkProps {
  label: string;
  description?: string;
  icon?: React.ReactNode;
  href: string;
  target?: React.HTMLAttributeAnchorTarget;
  className?: string;
}

/**
 * Replica of nav_link.tsx from the main site.
 * Used inside Dropdown children for navigation menus.
 */
export function NavLink({label, description, icon, href, target, className}: NavLinkProps) {
  return (
    <a
      href={href}
      target={target}
      rel={target === '_blank' ? 'nofollow noreferrer' : undefined}
      className={cn(
        'flex items-start px-[20px] py-[10px] transition-[background] duration-100 ease-out hover:bg-[#f8f8f8] lg:w-[420px]',
        className,
      )}>
      {icon && <div className='shrink-0 min-w-6'>{icon}</div>}
      <div className={cn(icon && 'ml-[20px]')}>
        <div className='font-bold'>{label}</div>
        {description && <div className='text-[13px] text-[#727579]'>{description}</div>}
      </div>
    </a>
  );
}

/**
 * Replica of MinimalNavLink from the main site.
 */
export function MinimalNavLink({label, href, target, className}: NavLinkProps) {
  return (
    <a
      href={href}
      target={target}
      rel={target === '_blank' ? 'nofollow noreferrer' : undefined}
      className={cn(
        'flex p-[10px] transition-[background] duration-100 ease-out hover:bg-[#f8f8f8] lg:w-[150px]',
        className,
      )}>
      <div className='font-bold'>{label}</div>
    </a>
  );
}
